import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { LINKS } from 'routes/constants'
import ImageMob1x from './consistent-mob1x.png'
import ImageMob2x from './consistent-mob2x.png'
import ImageDesk1x from './consistent-desk1x.png'
import ImageDesk2x from './consistent-desk2x.png'
import classes from './DifferenceConsistent.module.scss'

export const DifferenceConsistent = () => {
  return (
    <Block
      as={'section'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <hgroup className={classes.heading}>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Works for every external app
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          You are never blocked by us not having a Unified API for a specific
          app. You can always map it to more apps yourself or use our on-demand
          connectors service to add it within predictable time and for a
          predictable cost.
        </Text>
      </hgroup>

      <div className={classes.visual}>
        <picture className={classes.image}>
          <source
            media='(min-resolution: 2dppx) and (min-width: 768px)'
            srcSet={ImageDesk2x.src}
          />
          <source media='(min-width: 768px)' srcSet={ImageDesk1x.src} />
          <source
            media='(min-resolution: 2dppx) and (max-width: 767px)'
            srcSet={ImageMob2x.src}
          />
          <source media='(max-width: 767px)' srcSet={ImageMob1x.src} />
          <img
            src={ImageMob1x.src}
            alt='Works for every external app'
            loading='lazy'
          />
        </picture>
      </div>

      <Actions className={classes.actions}>
        <Link asPageButton type={'secondary'} href={LINKS.CONNECTOR_BUILDER}>
          AI connector builder
        </Link>
        <Link asPageButton type={'secondary'} href={LINKS.INTEGRATIONS}>
          Integrations library
        </Link>
      </Actions>
    </Block>
  )
}
